import { render, staticRenderFns } from "./assetsTab.vue?vue&type=template&id=66b38269"
import script from "./assetsTab.js?vue&type=script&lang=js&external"
export * from "./assetsTab.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports